import TablesPage from './list';

export default TablesPage;
